import React, { useState } from 'react'
import { tokens } from "../../../theme";
import {  MenuItem, SubMenu } from "react-pro-sidebar";
import { Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import AddchartIcon from '@mui/icons-material/Addchart';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AddCardIcon from '@mui/icons-material/AddCard';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import DescriptionIcon from "@mui/icons-material/Description";
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import Diversity1Icon from "@mui/icons-material/Diversity1";
import { Inventory, LocalMall } from "@mui/icons-material";
import BackpackIcon from '@mui/icons-material/Backpack';
import InventoryIcon from "@mui/icons-material/Inventory";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import OutboxIcon from '@mui/icons-material/Outbox';
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import EngineeringIcon from "@mui/icons-material/Engineering";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import CardTravelIcon from "@mui/icons-material/CardTravel";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import GavelIcon from "@mui/icons-material/Gavel";
import SecurityUpdateGoodIcon from "@mui/icons-material/SecurityUpdateGood";
import NotificationAddIcon from "@mui/icons-material/NotificationAdd";
import MoneyIcon from "@mui/icons-material/Money";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import AssignmentAddIcon from "@mui/icons-material/AssignmentAdd";
const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};


const RecursosHumanos = () => {
  const [selected, setSelected] = useState("Dashboard");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <>
                  <SubMenu
        title="Recursos Humanos"
        icon={<Diversity1Icon />}
        style={{ color: colors.grey[300] }}
      >
        {/* Consultas */}
        <Item
          title="Feriado"
          to="/feriados"
          icon={<EditCalendarIcon />}
          selected={selected}
          setSelected={setSelected}
        />
        <SubMenu
          title="Consultas"
          icon={<ReceiptOutlinedIcon />}
          style={{ color: colors.grey[300] }}
        >
          <Item
            title="Postulantes"
            to="/view/postulantes"
            icon={<EngineeringIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Grupos"
            to="/view/grupos"
            icon={<Diversity3Icon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Horarios"
            to="/view/horarios"
            icon={<AccessTimeIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Salarios"
            to="/view/salarios"
            icon={<AddCardIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Usuarios"
            to="/view/usuarios"
            icon={<PersonAddIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Horas Extras"
            to="/view/horasExtras"
            icon={<AccessTimeIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Banco de Horas"
            to="/view/banco"
            icon={<AccountBalanceIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Pagos"
            to="/view/pagos"
            icon={<RequestPageIcon />}
            selected={selected}
            setSelected={setSelected}
          />

          <Item
            title="Adelanto Funcionarios"
            to="/view/resumenAdelanto"
            icon={<CurrencyExchangeIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Adelanto Mes"
            to="/view/adelanto"
            icon={<CurrencyExchangeIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Vacaciones"
            to="/view/vacaciones"
            icon={<CardTravelIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Permisos"
            to="/view/permisos"
            icon={<MeetingRoomIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Historial de Intercambios"
            to="/view/swapHistory"
            icon={<MeetingRoomIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Nomina"
            to="/nomina"
            icon={<ContactPageIcon />}
            selected={selected}
            setSelected={setSelected}
          />
        </SubMenu>

        {/* Relatorios */}
        <SubMenu
          title="Relatorios"
          icon={<DescriptionIcon />}
          style={{ color: colors.grey[300] }}
        >
          <Item
            title="Resumen Funcionarios"
            to="/resumen"
            icon={<ReceiptOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Historial de Marcaciones"
            to="/lista/marcaciones"
            icon={<DescriptionIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Marcaciones Extras"
            to="/lista/marcacionesextras"
            icon={<DescriptionIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Historial de Descuentos"
            to="/view/descuento"
            icon={<DescriptionIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Historial de faltas"
            to="/view/faltas"
            icon={<AssignmentIndIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Adicional Nocturno"
            to="/view/adicional"
            icon={<MonetizationOnIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Aguinaldo Externo"
            to="/view/aguinaldoIps"
            icon={<DescriptionIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Aguinaldo Interno"
            to="/view/aguinaldoInterno"
            icon={<DescriptionIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Resumen Plus"
            to="/view/plusView"
            icon={<DescriptionIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Relatorio Plus"
            to="/view/metasView"
            icon={<DescriptionIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Liquidacion"
            to="/view/liquidation"
            icon={<GavelIcon />}
            selected={selected}
            setSelected={setSelected}
          />
        </SubMenu>

        {/* Registros */}
        <SubMenu
          title="Registros"
          icon={<PersonAddIcon />}
          style={{ color: colors.grey[300] }}
        >
          <Item
            title="Registro Postulantes"
            to="/registro/postulantes"
            icon={<PersonAddIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Registro Grupos"
            to="/registro/grupos"
            icon={<Diversity3Icon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Registro Usuario"
            to="/form"
            icon={<PersonAddIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Registro Faltas"
            to="/registration/faltas"
            icon={<MoneyOffIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Registro Salarios"
            to="/registro/salarios"
            icon={<AddCardIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Registro Horarios"
            to="/registro/horarios"
            icon={<AccessTimeIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Registro Descuentos"
            to="/registro/descuento"
            icon={<MoneyOffIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Permisos"
            to="/registro/permisos"
            icon={<SecurityUpdateGoodIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Permisos por Usuario"
            to="/registro/permisosUsuario"
            icon={<AssignmentIndIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Notificacion"
            to="/registro/notificacion"
            icon={<NotificationAddIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Banco de Horas"
            to="/registro/banco"
            icon={<AccountBalanceIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Registro Accesos"
            to="/registro/accesoEventos"
            icon={<AddchartIcon />}
            selected={selected}
            setSelected={setSelected}
          />
        </SubMenu>
        <SubMenu
          title="Pagos"
          icon={<MoneyIcon />}
          style={{ color: colors.grey[300] }}
        >
          <Item
            title="Registro Adelanto"
            to="/registro/adelanto"
            icon={<PriceChangeIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Registro Metas"
            to="/registro/metas"
            icon={<PriceChangeIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Registro Plus"
            to="/registration/plus"
            icon={<AddCardIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Registro Pagos"
            to="/registro/pagos"
            icon={<PriceChangeIcon />}
            selected={selected}
            setSelected={setSelected}
          />
        </SubMenu>
        <SubMenu
          title="Uniformes"
          icon={<LocalMall />}
          style={{ color: colors.grey[300] }}
        >
          <SubMenu
            title="Registros"
            icon={<AssignmentAddIcon />}
            style={{ color: colors.grey[300] }}
          >
            <Item
              title="Registrar Uniformes"
              to="/registro/uniformes"
              icon={<BackpackIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Registrar Stock"
              to="/registro/stockuniformes"
              icon={<InventoryIcon />}
              selected={selected}
              setSelected={setSelected}
            />
          </SubMenu>
          <SubMenu
            title="Consultas"
            icon={<ContentPasteSearchIcon />}
            style={{ color: colors.grey[300] }}
          >
            <Item
              title="Uniformes"
              to="/view/uniformes"
              icon={<EngineeringIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Stock Uniformes"
              to="/view/stockuniformes"
              icon={<CheckroomIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Top Uniformes"
              to="/view/topuniformes"
              icon={<WorkspacePremiumIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Historial de Entregas"
              to="/view/historialAsignacion"
              icon={<OutboxIcon />}
              selected={selected}
              setSelected={setSelected}
            />
          </SubMenu>
        </SubMenu>
      </SubMenu>
          </>
  )
}

export default RecursosHumanos
